import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { SessionService } from "@shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    return this.checkLogin();
  }

  checkLogin(): boolean | UrlTree {
    if (this.sessionService.isLoggedIn) {
      return true;
    } else {
      return this.router.createUrlTree(["/login"]);
    }
  }
}

export const AuthGuard: CanActivateFn = (): boolean | UrlTree => {
  return inject(AuthGuardService).canActivate();
};
